import React from 'react';
import TablaTerritorios from './TablaTerritorios';

const DatosCamara_Territorios = ({data,title}) => {
    return(
        <article className='resumenTerritorios'>
            <div className="subHeader">{title}</div>
            <div className="content">
                <TablaTerritorios data={data}></TablaTerritorios>
            </div>
        </article>
    );
};

export default DatosCamara_Territorios;